import { useEffect, useState } from 'react';

const DARK_MODE_QUERY = '(prefers-color-scheme: dark)';

/**
 * Checks to see if the browser prefers dark mode or not.
 * Note: this is not the user's theme setting in the app,
 * but the browser preference.
 *
 * @returns true if the browser prefers-color-scheme: dark
 */
export function usePrefersDarkMode() {
  const [prefersDark, setPrefersDark] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia(DARK_MODE_QUERY);
    setPrefersDark(mediaQuery.matches);

    function updateSystemPreference(e: MediaQueryListEvent) {
      setPrefersDark(e.matches);
    }

    mediaQuery.addEventListener('change', updateSystemPreference);

    return () => mediaQuery.removeEventListener('change', updateSystemPreference);
  }, []);

  return prefersDark;
}
